<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal _page-constructor"  [ngClass]="{'show': showModal}">
    <form #form="ngForm">
        <!--<div class="modal-backdrop fade in">-->
            <div class="modal-dialog module-crud-notice">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" (click)="hideModal()">
                            <span>×</span><span class="sr-only">Close</span>
                        </button>
                        <h2 class="text-center m-n">How will you be creating this notice?</h2>
                    </div>
                    <div class="modal-body _page-start">
                        <div class="row m-n">
                            <div class="col-md-10 col-md-offset-1">
                                <div class="_items">
                                    <div class="_item" (click)="wizardType('scratch')">
                                        <div class="_icon"><i class="fa fa-file-o"></i></div>
                                        <div class="_title">Create from Scratch</div>
                                        <div class="_descr">
                                            Create a Notice from scratch using your own customization
                                        </div>
                                        <button type="button" class="btn btn-block btn-lg btn-primary">Start now</button>
                                    </div>
                                    <div class="_item" (click)="wizardType('templates')">
                                        <div class="_icon"><i class="fa fa-file-text-o"></i></div>
                                        <div class="_title">Create from a Template</div>
                                        <div class="_descr">
                                            Use a template from our library and customize it to make it own
                                        </div>
                                        <button type="button" class="btn btn-block btn-lg btn-primary">Select a Template</button>
                                    </div>
                                    <div class="_item" (click)="wizardType('pdf')" >
                                        <div class="_icon"><i class="fa fa-file-pdf-o"></i></div>
                                        <div class="_title">Create from a PDF</div>
                                        <div class="_descr">
                                            Select a PDF you have on file and upload
                                        </div>
                                        <button type="button" class="btn btn-block btn-lg btn-primary">Upload a PDF</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!--</div>-->
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/notices/create-notice-wizard/create-notice-wizard.component.html